<template>
  <div>

      <v-alert type="success" icon="account_circle" elevation="5" :color="scdColor" outlined>
        <div class="d-flex align-center justify-space-between">
          <div class="d-flex flex-column align-start pr-3">
            <div class="_dato">{{ titolo }}</div>
            <v-text-field 
              class="_titolo"
              :rules="[vincoli.required]"
              v-model="dato"/>         
          </div>
          <div>
            <v-btn
              class="_copy_button"
              v-clipboard:copy="dato"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError">
              Copia
            </v-btn>
          </div>
        </div>
      </v-alert>

  </div>
</template>

<script>
import mixin from '../mixins';

export default {
  props: {
    titolo : String,
    dato : String,
  },
  data() {
    return {
      // coloreBottoneCopia: 
      // message: 'Copy These Text'
    }
  },
  methods: {
    onCopy: function (e) {
      // alert('You just copied: ' + e.text)
    },
    onError: function (e) {
      // alert('Failed to copy texts')
    }
  }
}
</script>

<style scoped lang="scss">
  ._dati-azienda ::v-deep {
      height: calc(100vh - 60px);
    ._titolo {
      font-weight: 700;
      font-size: 20px;
      color: #272727;
    }
    ._copy_button {
      margin-left: 10px;
      color: white;
      background-color: #6D94CD!important;
    }
    ._dato {
      font-size: 18px;
      color: #6D94CD;
    }
  }
</style>